// extracted by mini-css-extract-plugin
module.exports = {"spaced2Row":"editor_spaced2Row__wiwPm","switchRow":"editor_switchRow__3SRmh","checkedRow":"editor_checkedRow__3x-rQ","tabGrid":"editor_tabGrid__2hMQH"};